var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReintegros(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.783,
    height: 62.414,
    viewBox: "0 0 63.783 62.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_165632",
    "data-name": "Grupo 165632",
    transform: "translate(2.296 2.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_163827",
    "data-name": "Grupo 163827",
    transform: "translate(25.009 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_85698",
    "data-name": "Trazado 85698",
    d: "M0,1.65A21.653,21.653,0,0,0,14.061,13.024,21.763,21.763,0,0,0,39.7,0M27.457,0",
    transform: "translate(22.371 41.091) rotate(-121)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_85681",
    "data-name": "Trazado 85681",
    d: "M0,6.624l3.83-3.83L6.624,0m0,13.248L0,6.624",
    transform: "matrix(0.999, 0.035, -0.035, 0.999, 0.462, 0.713)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_85714",
    "data-name": "Trazado 85714",
    d: "M5,11.409l4.409,4.409L18.226,7",
    transform: "translate(18.466 17.944)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_85715",
    "data-name": "Trazado 85715",
    d: "M40.83,14.776A21.765,21.765,0,0,0,0,13.713",
    transform: "translate(21.029 57.488) rotate(-121)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_85716",
    "data-name": "Trazado 85716",
    d: "M0,6.853,3.962,2.891,6.853,0m0,13.706L0,6.853",
    transform: "matrix(-0.995, -0.105, 0.105, -0.995, 33.104, 57.571)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReintegros);
export default __webpack_public_path__ + "static/media/reintegros.da523a5d4fb68b1dee6f9dab0bbebf6a.svg";
export { ForwardRef as ReactComponent };